<!-- AI Generated Template -->
<table-container [collection]="titles" [progress]="promise" (onPageChange)="pageChange($event)" (onPerPageChange)="perPageChange($event)">
    <table class="table table-hover seo-issues">
        <thead>
            <tr>
                <th monTableSort
                    monSortBy="title"
                    [monSortDirection]="currentSort.direction"
                    [monCurrentlySortedBy]="currentSort.by"
                    (monOnSorted)="onSortChanged($event)"
                    >{{ 'Title' | translate }}</th>
                <th monTableSort
                    monSortBy="page_count"
                    [monSortDirection]="currentSort.direction"
                    [monCurrentlySortedBy]="currentSort.by"
                    (monOnSorted)="onSortChanged($event)"
                    class="text-right border-right">
                    <span class="pr-3" >{{ 'Appears on' | translate }}</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr [class.selected]="title === selectedTitle"
                (click)="changeSelectedTitle(title)"
                *ngFor="let title of titles">
                <td class="text-v-middle">
                    <a>{{ title.title }}</a>
                </td>
                <td class="text-v-middle text-right">
                    <pages-button (callback)="changeSelectedTitle(title)" [ngModel]="title.page_count"></pages-button>
                </td>
            </tr>
        </tbody>
    </table>
</table-container>
